import * as APIUtils from '@components/Globals/Utils';
import type { ApiConfig } from '../types';
import { socketService } from '@/services/socketService';

class MenuApi
{
  static getPeopleData(requestApi: ApiConfig)
  {
    return APIUtils.callFetch(requestApi, 'api/Person/GetPeopleData/', 'GET');
  }

  static getByConfigValuePerson(requestApi: ApiConfig, projectId: number)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/menu/getByConfigValuePerson?projectId=' + projectId,
      'GET',
    );
  }

  static getCustomFieldsByItemId(
    requestApi: ApiConfig,
    CoreTaskId: number,
    IsDeleted: boolean,
    ProjectId: number,
  )
  {
    return APIUtils.callFetch(
      requestApi,
      'api/CustomField/GetCustomFieldsByItemId?CoreTaskId=' +
        CoreTaskId +
        '&IsDeleted=' +
        IsDeleted +
        '&ProjectId=' +
        ProjectId,
      'GET',
    );
  }

  static getEvents(requestApi: ApiConfig, requestParams: any)
  {
    return APIUtils.callFetch(requestApi, 'api/TaskTimeTracking/GetEvents', 'POST', requestParams);
  }

  static TaskTimeTracking(requestApi: ApiConfig, requestParams: any)
  {
    return APIUtils.callFetch(requestApi, 'api/TaskTimeTracking', 'POST', {
      ...requestParams,
      SocketConnectionId: socketService.connectionId,
    });
  }

  static getBasicFieldValueByUrl(requestApi: ApiConfig, url: string)
  {
    return APIUtils.callFetch(requestApi, url, 'GET');
  }

  static getPhasesByConversationId(requestApi: ApiConfig, ConversationId: number)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/Conversation/GetPhasesByConversationId?ConversationId=' + ConversationId,
      'GET',
    );
  }

  static getEmptyCustomFieldsByConfigValueId(requestApi: ApiConfig, configValueId: number)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/configvalue/GetEmptyCustomFieldsByConfigValueId?configValueId=' + configValueId,
      'GET',
    );
  }

  static getMetrics(requestApi: ApiConfig, conversationId: number)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/DailyAssetMetric/GetDailyMetricList?conversationId=' + conversationId,
      'GET',
    );
  }

  static deleteReplyTimeTrackings(requestApi: ApiConfig, replyId: number)
  {
    return APIUtils.callFetch(
      requestApi,
      'api/TaskTimeTracking/DeleteReplyTimeTrackings?replyId=' +
        replyId +
        '&socketid=' +
        (socketService.connectionId || ''),
      'POST',
      undefined,
      true,
    );
  }
}

export default MenuApi;
